// MSAL configuration
export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID || '';
export const MSAL_AUTHORITY = import.meta.env.VITE_MSAL_AUTHORITY || '';
export const MSAL_REDIRECT_URI = import.meta.env.VITE_MSAL_REDIRECT_URI || 'http://localhost:3000/';
export const MSAL_SCOPES = [import.meta.env.VITE_MSAL_SCOPE || ''];

export const APP_ENV = import.meta.env.VITE_APP_ENV || 'dev';
export const API_URL = import.meta.env.VITE_API_URL || '';

export const CLARITY_ID = import.meta.env.VITE_CLARITY_ID || 'undefined';
